import { COVERGO_SAAS_DEV, COVERGO_ASIA_QA, COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const msig = {

	// msig_test
	"msig-test-studio.dev.asia.covergo.cloud": {
		appConfig: { tenantId: "msig_test", appId: "covergo_crm" },
		envConfig: COVERGO_SAAS_DEV,
	},

	//msig_qax
	"msig-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "msig_qax",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
	},
	// msig_qa
	"studio.msig.qa.ap-east-1.covergo.cloud": {
		appConfig: { tenantId: "msig_qa", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.msig.qa.ap-east-1.covergo.cloud/graphql",
			COVERGO_FILE_SYSTEM: "https://api.msig.qa.ap-east-1.covergo.cloud/api/v1/files",
		},
	},

	// msig_qa-rs (external)
	"studio.msig.qa-rs.ap-east-1.covergo.cloud": {
		appConfig: { tenantId: "msig_qa", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.msig.qa-rs.ap-east-1.covergo.cloud/graphql",
			COVERGO_FILE_SYSTEM: "https://api.msig.qa-rs.ap-east-1.covergo.cloud/api/v1/files",
		},
	},

	// msig_qa-rs (internal)
	"studio.qa-rs.covergoaws.msighkcloud.net": {
		appConfig: { tenantId: "msig_qa", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.qa-rs.covergoaws.msighkcloud.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.qa-rs.covergoaws.msighkcloud.net/api/v1/files",
		},
	},

	// msig_uat
	"msig-studio.uat.msig.asia.covergo.net": {
		appConfig: { tenantId: "msig_uat", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.uat.msig.asia.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.uat.msig.asia.covergo.net/api/v1/files",
		},
	},
	
	// msig_prod
	"studio.prod.covergoaws.msighkcloud.net": {
		appConfig: { tenantId: "msig_prod", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.prod.covergoaws.msighkcloud.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.prod.covergoaws.msighkcloud.net/api/v1/files",
		},
	},

	// msig_ih_uat
	"msig-ih-studio.preprod.asia.covergo.cloud": { 
		appConfig: { 
			tenantId: "msigih_preprod", 
			appId: "covergo_crm" 
		}, 
		envConfig: COVERGO_ASIA_PRE_PROD,
		fileSystem: {
			bucketName: "covergo-apse1-preprod-msigih-preprod"
		}
	},
	
}
